import { Delta, getTransformStyle } from '@lidojs/design-core';
import { RiArrowLeftSLine } from '@remixicon/react';
import React, {
  FC,
  PropsWithChildren,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useShowSub } from '../../hooks/useShowSub';

interface SubMenuProps {
  transform: Delta;
}

const SubMenu: FC<PropsWithChildren<SubMenuProps>> = ({
  transform,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [offset, setOffset] = useState<{ x: number; y: number }>({
    x: -9999,
    y: -9999,
  });

  const { setShowSub } = useShowSub();

  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      const offset = {
        x: 0,
        y: 0,
      };
      const parentRect = ref.current.parentElement;
      const rect = ref.current.getBoundingClientRect();
      if (
        transform.y + parentRect.offsetTop + rect.height >
        window.innerHeight
      ) {
        offset.y =
          parentRect.offsetTop -
          (transform.y +
            parentRect.offsetTop +
            rect.height -
            window.innerHeight);
      } else {
        offset.y = parentRect.offsetTop;
      }
      if (
        transform.x + parentRect.offsetWidth + rect.width >
        window.innerWidth
      ) {
        offset.x = -rect.width;
      } else {
        offset.x = parentRect.offsetLeft + parentRect.offsetWidth;
      }
      setOffset(offset);
    }
  }, [transform]);

  const handleClose = () => {
    setShowSub(false);
  };

  return (
    <div
      ref={ref}
      css={{
        position: 'fixed',
        top: 0,
        left: 0,
        transform: getTransformStyle({
          position: offset,
        }),
        paddingLeft: 8,
        paddingRight: 8,
        '@media (max-width: 1024px)': {
          paddingLeft: 0,
          paddingRight: 0,
          top: 'unset',
          bottom: 0,
          width: '100%',
          transform: 'unset',
          zIndex: 10,
        },
      }}
    >
      <div
        css={(theme) => ({
          background: theme.colors.background,
          borderRadius: 4,
          zIndex: 30,
          '@media (min-width: 900px)': {
            boxShadow:
              '0 0 0 1px rgba(64,87,109,.07),0 2px 12px rgba(53,71,90,.2)',
          },
        })}
      >
        <div
          css={{
            '@media (max-width: 1024px)': {
              display: 'flex',
              alignItems: 'center',
              height: 80,
            },
          }}
        >
          <div
            css={(theme) => ({
              display: 'none',
              '@media (max-width: 1024px)': {
                flexShrink: 0,
                fontSize: 24,
                width: 48,
                height: 48,
                borderRadius: '50%',
                background: theme.colors.defaultButton,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                margin: 16,
                WebkitFlexShrink: 0,
              },
            })}
            onClick={handleClose}
          >
            <RiArrowLeftSLine size={60} />
          </div>

          <div
            css={{
              padding: '8px 0px',
              '@media (max-width: 1024px)': {
                padding: '8px 16px',
                display: 'flex',
                alignItems: 'center',
                flexGrow: 1,
                overflowX: 'auto',
              },
            }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubMenu;
